module.exports = __webpack_public_path__ + "img/software.4582d161.png";